export default __webpack_public_path__ + "static/media/H.b3923d8c.svg";